import type { DatasetPlanPositioningProviderProps } from "./dataset-plan-positioning.type";

import { DatasetPlanPositioningContext } from "./dataset-plan-positioning.context";
import { useDatasetPlanPositioningProvider } from "./dataset-plan-positioning.hook";

const DatasetPlanPositioningProvider = ({
  children,
  ...props
}: DatasetPlanPositioningProviderProps) => {
  const values = useDatasetPlanPositioningProvider(props);

  return (
    <DatasetPlanPositioningContext.Provider value={values}>
      {children}
    </DatasetPlanPositioningContext.Provider>
  );
};

export default DatasetPlanPositioningProvider;
